import Vue from 'vue';
import WorkOrderActions from './actions/workorders';
import OrganisationConfigurationActions from './actions/organisationconfiguration';
import DefaultClientActionsActions from './actions/defaultclientactions';
import ClientActionsActions from './actions/clientactions';

//If you add a custom repository in this array it will be dynamically added to the repository custom options when get: is called.
const actions = {
  workorders: WorkOrderActions,
  organisationconfiguration: OrganisationConfigurationActions,
  defaultclientactions: DefaultClientActionsActions,
  clientactions: ClientActionsActions
};

class Repository {
  //Generate a repository for the resource (The /controller route with all the main and custom routes)
  constructor(resource, organisationCode) {
    this.resource = resource;
    this.organisationCode = organisationCode;
    this.customConfig = {
      headers: {
        Organisationcode: organisationCode,
      },
    };

    let customActions = actions[resource];

    if (customActions != undefined) {
      this.actions = new customActions(
        this.resource,
        this.organisationCode,
        this.customConfig
      );
    }
  }

  getAll() {
    return Vue.prototype.$axiosMainClient.get(`organisations/${this.organisationCode}/${this.resource}`, this.customConfig);
  }
  
  requestAll(request) {
    return Vue.prototype.$axiosMainClient.post(`organisations/${this.organisationCode}/${this.resource}`, request, this.customConfig);
  }
  get(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `organisations/${this.organisationCode}/${this.resource}/${idPublic}`,
      this.customConfig
    );
  }
  create(payload) {
    return Vue.prototype.$axiosMainClient.post(
      `organisations/${this.organisationCode}/${this.resource}`,
      payload,
      this.customConfig
    );
  }
  update(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `organisations/${this.organisationCode}/${this.resource}/${idPublic}`,
      payload,
      this.customConfig
    );
  }
  delete(idPublic) {
    return Vue.prototype.$axiosMainClient.delete(
      `organisations/${this.organisationCode}/${this.resource}/${idPublic}`,
      this.customConfig
    );
  }
}

//When you get any repository with his name in parameter it will generate a repository with all the default and custom routes.
export default {
  get: (name, organisationCode = 0) => {
    return new Repository(name, organisationCode);
  },
};
